import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Button,
} from '@material-ui/core';
import { Rating } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ratingContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: '8px',
      marginTop: '12px',
      marginBottom: '12px',
    },
    ratingStars: {
      marginBottom: '0',
    },
    ratingText: {
      fontSize: '14px',
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    reviewCount: {
      fontSize: '12px',
      color: theme.palette.text.secondary,
      opacity: 0.7,
      marginTop: '0',
      padding: '0',
      minWidth: 'auto',
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
      },
    },
  }),
);

interface RatingDisplayProps {
  rating: number;
  reviewCount: number;
  onReviewsClick?: () => void;
}

export const RatingDisplay: React.FC<RatingDisplayProps> = ({
  rating,
  reviewCount,
  onReviewsClick,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.ratingContainer}>
      <Rating
        value={rating}
        precision={0.1}
        readOnly
        size="small"
        className={classes.ratingStars}
      />
      {reviewCount > 0 && (
        <Typography className={classes.ratingText}>
          {rating.toFixed(1)}
        </Typography>
      )}
      <Button onClick={onReviewsClick} className={classes.reviewCount}>
        {reviewCount === 0
          ? '(Be the first to rate!)'
          : `(${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'})`}
      </Button>
    </Box>
  );
};
